<template>
  <div :class="{query: true}">
    <NavHome class="queryNav" v-once/>
    <router-view v-wechat-title="$t($route.meta.title) + ' - ' + $t('app.name')"></router-view>
    <Footer/>
  </div>
</template>

<script>
import NavHome from './layout/NavHome'
import Footer from './layout/Footer2'
export default {
  name: 'Enjoy',
  components: { NavHome, Footer }
}
</script>


// WEBPACK FOOTER //
// src/components/Enjoy.vue